import { render, staticRenderFns } from "./ManageVINMVS.vue?vue&type=template&id=f0074d8c&scoped=true&"
import script from "./ManageVINMVS.vue?vue&type=script&lang=js&"
export * from "./ManageVINMVS.vue?vue&type=script&lang=js&"
import style0 from "./ManageVINMVS.vue?vue&type=style&index=0&id=f0074d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0074d8c",
  null
  
)

export default component.exports